import { useState, useRef, useEffect } from "react";
import { useInlineValidation, InlineFieldError } from "./inlineValidation";

const FloatingLabelTextArea = ({ id, label, handleChange, handleBlur, value, error='', name, type = 'text', required=false, placeholder = '', rows="8", cols="50" }) => {
    const [isFocused, setIsFocused] = useState(false);
    const refContainer = useRef(null);
    // Inline message instead of the browser's "Please fill out this field." bubble.
    const { message: invalidMessage, onInvalid } = useInlineValidation({ label, value });

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleClickOutside = (event) => {
        if (refContainer.current && !refContainer.current.contains(event.target)) {
            setIsFocused(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    
    return (
      <>
      <div className={`relative border rounded-md ${invalidMessage ? 'border-red-400 ring-1 ring-red-200' : ''}`} ref={refContainer}>
        <textarea
          type={type}
          id={id}
          value={value}
          name={name}
          rows={rows}
          cols={cols}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required={required}
          onInvalid={onInvalid}
          placeholder={placeholder}
          className={`w-full pl-4 border-none outline-none ring-0 focus:ring-0 ${value || isFocused ? 'bg-white' : 'bg-gray-50'}`}
        />
        <label
          htmlFor={id}
          className={`absolute left-1 top-0 px-1 text-gray-500 text-sm transition-all ${value || isFocused ? '-translate-y-5 scale-75' : 'translate-y-1/2'}`}
        >
          {label}
          { required && <span className="text-red-600">*</span>}
        </label>
        {error && <p className="absolute left-2 top-12 text-xs text-red-500">{error}</p>}
      </div>
      {!error && <InlineFieldError message={invalidMessage} />}
      </>
    );
  };


export default FloatingLabelTextArea;